// src/components/admin/AdminNav.tsx
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import elPaketLogoIMG from "../../assets/images/logo-elpaket.png";
import { useAdminAuth } from "../../context/AdminAuthContext";

import "../../styles/app/Nav.css";

const AdminNav: React.FC = () => {
    const navigate = useNavigate();
    const { adminData, logoutAdmin } = useAdminAuth();
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const leaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                if (leaveTimeoutRef.current) {
                    clearTimeout(leaveTimeoutRef.current);
                    leaveTimeoutRef.current = null;
                }
                setUserDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            if (leaveTimeoutRef.current) {
                clearTimeout(leaveTimeoutRef.current);
            }
        };
    }, []);

    const handleMouseEnter = () => {
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
            leaveTimeoutRef.current = null;
        }
        setUserDropdownOpen(true);
    };

    const handleMouseLeave = () => {
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
        }
        leaveTimeoutRef.current = setTimeout(() => {
            setUserDropdownOpen(false);
        }, 450);
    };

    const handleLogoutAction = async () => {
        try {
            await logoutAdmin();
            navigate("/admin/login", { replace: true });
        } catch (error) {
            console.error("Error logging out admin:", error);
        }
    };

    return (
        <nav className="nav">
            <div className="nav-container">
                <div className="nav-left">
                    <img
                        src={elPaketLogoIMG}
                        alt="elPaket"
                        className="nav-logo-img"
                        style={{ height: "44px", objectFit: "contain", cursor: "pointer" }}
                        onClick={() => navigate('/')}
                    />
                </div>

                {/* Placeholder para mantener el grid (logo izquierda, placeholder centro, acciones derecha) */}
                <div className="nav-placeholder"></div>

                <div className="nav-actions">
                    {/* Botón de admin para dashboard */}
                    {adminData && (
                        <div
                            className="nav-user-dropdown-container"
                            ref={dropdownRef}
                        >
                            <button
                                onClick={() => {
                                    setUserDropdownOpen(prev => !prev);
                                }}
                                className="nav-login-btn-text"
                                title={`${adminData.FirstName} ${adminData.LastName}`}
                            >
                                <FontAwesomeIcon icon={faUser} />
                                <span>{adminData.FirstName} {adminData.LastName}</span>
                            </button>
                            {userDropdownOpen && (
                                <div className="nav-user-dropdown-menu">
                                    <button
                                        onClick={() => {
                                            navigate("/admin/dashboard");
                                            setUserDropdownOpen(false);
                                        }}
                                        className="nav-user-dropdown-item"
                                    >
                                        Mi Cuenta
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleLogoutAction();
                                            setUserDropdownOpen(false);
                                        }}
                                        className="nav-user-dropdown-item logout"
                                    >
                                        Cerrar Sesión
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default AdminNav;
